import { Alert02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

import { DropdownMenuLabel } from './dropdown-menu';
import { getEnvironment } from './lib/environment';

/**
 * Non-interactive environment cue for the UserNav dropdown, sitting above
 * "Change Partner" so an admin is reminded of the environment every time they
 * open the partner switcher. Deliberately loud on production (the one
 * environment with no banner) — a red exclamation icon and bold "Production";
 * subtle on local/staging.
 */
export function EnvironmentIndicator() {
  const env = getEnvironment();

  if (env === 'production') {
    return (
      <DropdownMenuLabel className="text-destructive flex items-center gap-1.5 text-sm font-bold">
        <HugeiconsIcon icon={Alert02Icon} strokeWidth={2} className="size-4" />
        Production
      </DropdownMenuLabel>
    );
  }

  return <DropdownMenuLabel>{env === 'staging' ? 'Staging' : 'Local'}</DropdownMenuLabel>;
}
